// Quotes & presentations API client (2026-10-19).
//
//   GET /portal/quotes — every quote and presentation sent to this client.
//
// Read-only. `reviewUrl` is the same /o/:uuid or /p/:uuid link the emails
// carry (built server-side by one shared function); the portal opens it in
// the same tab and approval happens there — never through a portal endpoint.
import { api } from "@/lib/api";

export type PortalQuoteStatus =
  | "awaiting_approval"
  | "changes_requested"
  | "approved"
  | "review_only"
  | "complete";

export type PortalPresentationStatus =
  | "ready_to_review"
  | "viewed"
  | "feedback_sent"
  | "approved"
  | "changes_requested";

export interface PortalQuote {
  id: string;
  orderNumber: number;
  projectName: string;
  sentAt: string | null;
  status: PortalQuoteStatus;
  statusLabel: string;
  reviewUrl: string;
}

export interface PortalPresentation {
  id: string;
  presentationNumber: number;
  projectName: string;
  sentAt: string | null;
  status: PortalPresentationStatus;
  statusLabel: string;
  reviewUrl: string;
}

export interface PortalQuotesResult {
  quotes: PortalQuote[];
  presentations: PortalPresentation[];
}

export const PORTAL_QUOTES_KEY = ["portal-quotes"] as const;

export async function fetchPortalQuotes(): Promise<PortalQuotesResult> {
  return api<PortalQuotesResult>("/portal/quotes");
}

/** Pill colours — the same brown/cream/ok/warn family as the order pills. */
export const QUOTE_PILL_CLASS: Record<PortalQuoteStatus | PortalPresentationStatus, string> = {
  awaiting_approval: "bg-warn-bg text-warn",
  ready_to_review: "bg-warn-bg text-warn",
  changes_requested: "bg-peach-100 text-brown-500",
  review_only: "bg-cream-100 text-brown-500",
  viewed: "bg-cream-100 text-brown-500",
  feedback_sent: "bg-cream-100 text-brown-500",
  approved: "bg-ok-bg text-ok",
  complete: "bg-cream-200 text-brown-400",
};
